// Hold and resume (T7): the reason, how long, and "Answer received" once the
// build issue it waits on is resolved in Manufacturing.
import type { BuildDetailResponse } from '../../api/generated/BuildDetailResponse';
import type { useBuildActions } from '../../api/queries';
import { Button, ErrorPanel } from '../../design/components';
import { formatDateTime, formatDuration } from '../../design/format';
import { HOLD_REASONS } from './ProblemDialog';

export function HoldPanel({
    build,
    actions,
    canAct,
}: {
    build: BuildDetailResponse;
    actions: ReturnType<typeof useBuildActions>;
    canAct: boolean;
}) {
    if (build.summary.state !== 'OnHold') return null;
    const hold = build.holds.at(-1);
    if (!hold) return null;
    const reason = HOLD_REASONS.find((option) => option.value === hold.reason)?.label ?? hold.reason;
    const answered = hold.issueStatus === 'Resolved';
    return (
        <section className="sf-note sf-note--danger sf-stack" aria-labelledby="hold-heading">
            <h2 id="hold-heading" style={{ margin: 0 }}>
                On hold: {reason}
            </h2>
            <div>
                Since {formatDateTime(hold.placed.at)} ({formatDuration(hold.placed.at)}), by {hold.placed.displayName}.
            </div>
            {hold.note ? <div>“{hold.note}”</div> : null}
            {answered ? (
                <div className="sf-pill sf-pill--success" role="status">
                    Answer received
                </div>
            ) : null}
            {hold.issueStatus === 'Open' ? <div>Waiting for the answer in Manufacturing.</div> : null}
            {canAct ? (
                <div>
                    <Button
                        large
                        variant={answered ? 'primary' : 'outlined'}
                        disabled={actions.resume.isPending}
                        onClick={() => {
                            actions.resume.mutate();
                        }}
                    >
                        Resume
                    </Button>
                </div>
            ) : null}
            {actions.resume.isError ? <ErrorPanel error={actions.resume.error} /> : null}
        </section>
    );
}
